<template>
  <grid-container class="sjt-container">
    <div class="information-bar flex justify-space-between">
      <span>{{ $t('GameInfo') }}</span>

      <span>{{testName}}</span>

      <vue-countdown :time="timeRemaining" @end="onCountdownEnd" v-slot="{ hours, minutes, seconds }">
        <span style="color: blue">Time Remaining：{{hours}} hour, {{ minutes }} minutes, {{ seconds }} seconds</span>
      </vue-countdown>

      <span>{{ $t('Test') }}: <strong>{{ softSkillIndex + 1 }}</strong>/{{ testsCounter }}</span>

      <span>{{ $t('Question') }}: <strong>{{ currentQuestionIndex }}</strong>/{{ testQuestionsCounter }}</span>
    </div>

    <div class="white-bubble">
      <h5>{{ $t('Question') }}</h5>
      <span v-html="currentQuestion ? currentQuestion.questionText : ''"></span>
    </div>
    <div v-if="currentQuestion.bgDesktopPath">
      <img class="question-img" :src="currentQuestion.bgDesktopPath"/>
    </div>

    <el-table :gutter="$gutter" :data="options" class="width-100 responses-table">
      <el-table-column prop="optionText" :label="$t('Response')">
        <template slot-scope="scope">
          <span v-html="scope.row.optionText"></span>
        </template>
      </el-table-column>
      <el-table-column :width="90">
        <template slot="header">
          <el-tooltip effect="dark" content='You can only choose one option as "Your Choice"' placement="top">
            <span>{{ $t('YourChoice') }}</span>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <el-radio v-model="bestChoiceID" :label="scope.row.id">&nbsp;</el-radio>
        </template>
      </el-table-column>
    </el-table>

    <div v-show="showSubmit" class="submit-answer text-right width-100">
      <el-button type="primary" @click="submit">{{ $t('SubmitAnswer') }}</el-button>
    </div>
  </grid-container>
</template>

<script>
import axios from '@/axios/axios'
import VueCountdown from '@chenfengyuan/vue-countdown'

export default {
  name: 'SJT',
  components: { VueCountdown },
  computed: {
    gameplayProfile() {
      return this.$store.getters.gameplayProfile
    },

    softSkills() {
      return this.$store.getters.softSkills
    },

    softSkillsInvited() {
      return this.$store.getters.softSkillsInvited
    },

    softSkillsInvitedIndex() {
      return this.$store.getters.softSkillsInvitedIndex
    },

    justFinishedInvitation() {
      return this.$store.getters.justFinishedInvitation
    },

    isCompleted() {
      return this.$store.getters.isCompleted
    },

    totalQuestionsCounter() {
      return this.$store.getters.totalQuestionsCounter
    },

    testQuestionsCounter() {
      const softSkill = this.softSkills[this.softSkillIndex]
      return softSkill.questions.length
    },

    testsCounter() {
      return this.softSkillsInvited.length
    },

    currentQuestion() {
      let currentQuestion = null

      for (let softSkillIndex = 0; softSkillIndex < this.softSkills.length; softSkillIndex++) {
        const softSkill = this.softSkills[softSkillIndex]

        if (softSkill.status !== 'FINISHED') {
          for (let questionIndex = 0; questionIndex < softSkill.questions.length; questionIndex++) {
            const question = softSkill.questions[questionIndex]

            if (!question.answered) {
              currentQuestion = question
              break
            }
          }
          break
        }
      }

      return currentQuestion
    },

    softSkillIndex() {
      return this.$store.getters.softSkillIndex
    },

    softSkillInvitedIndex() {
      return this.$store.getters.softSkillInvitedIndex
    },

    testName() {
      const currentSkill = this.softSkillsInvited[this.softSkillIndex]

      if (currentSkill.name == 'RESILIENCE') {
        return 'Electricians Test'
      }

      if (currentSkill.name == 'ADAPTABILITY') {
        return 'Operator Test'
      }

      if (currentSkill.name == 'DECISION_MAKING') {
        return 'Technicians Test'
      }

      return 'General Test'
    },

    currentQuestionIndex() {
      let currentQuestionIndex = 0

      for (let softSkillIndex = 0; softSkillIndex < this.softSkills.length; softSkillIndex++) {
        const softSkill = this.softSkills[softSkillIndex]

        if (softSkill.status !== 'FINISHED') {
          for (let questionIndex = 0; questionIndex < softSkill.questions.length; questionIndex++) {
            const question = softSkill.questions[questionIndex]

            if (!question.answered) {
              currentQuestionIndex = 1 + questionIndex
              break
            }
          }
          break
        }
      }

      return currentQuestionIndex
    },

    timeRemaining() {
      if (this.initialAnswerTime != null) {
        const answeredTime = new Date(this.initialAnswerTime)
        const currentTime = new Date()

        const msDiff = currentTime - answeredTime

        const limit = Math.floor(90 * 1000 * 60)

        if (limit - msDiff > 0) {
          return limit - msDiff
        }
        return 0
      }
      else {
        return 90 * 60 * 1000
      }
    },

    options() {
      return this.currentQuestion ? this.shuffle(this.currentQuestion.options) : []
    },

    showSubmit() {
      return this.bestChoiceID
    }
  },
  data() {
    return {
      bestChoiceID: null,
      questionStartTime: Date.now(),
      initialAnswerTime: null
    }
  },
  created() {
    if (this.initialAnswerTime == null) {
      const firstQuestion = this.softSkills[0].questions[0]
      if (firstQuestion.answeredTime) {
        this.initialAnswerTime = firstQuestion.answeredTime
      }
      else {
        this.initialAnswerTime = new Date()
      }
    }
  },
  methods: {
    getPreviousQuestion() {
      if (this.currentQuestionIndex !== 0) {
        return this.softSkills[this.softSkillIndex].questions[this.currentQuestionIndex - 1]
      }
      return null
    },
    onCountdownEnd() {
      axios.post('game/time-up', {
        playerResultId: parseInt(this.$store.getters.playerResultId),
        softSkillsInvited: []
      })
        .then(res => {
          this.$router.replace('/sjt/timeup')
        })
    },
    shuffle: function(arr) {
      for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1))
        var temp = arr[i]
        arr[i] = arr[j]
        arr[j] = temp
      }

      return arr
    },

    submit() {
      const msec = Date.now() - this.questionStartTime
      const questionSecondsTaken = Math.round(msec / 1000)

      axios.post('game/answer', {
        playerResultId: this.$store.getters.playerResultId,
        bestOptions: [this.bestChoiceID],
        questionSecondsTaken: questionSecondsTaken,
        optionSecondsTaken: 0
      })
        .then(res => {
          this.setupNextQuestion()
        })
    },

    setupNextQuestion() {
      // Mark current q as complete
      this.currentQuestion.answered = true

      if (this.initialAnswerTime == null) {
        const firstQuestion = this.softSkills[0].questions[0]
        if (firstQuestion.answeredTime) {
          this.initialAnswerTime = firstQuestion.answeredTime
        }
        else {
          this.initialAnswerTime = new Date()
        }
      }

      // If this is the last question of the skill
      if (!this.currentQuestion) {
        // Mark the skill completed
        this.softSkills[this.softSkillIndex].status = 'FINISHED'

        if (this.justFinishedInvitation) {
          this.$store.dispatch('setGameComplete', {
            playerResultId: this.$store.getters.playerResultId,
            softSkillsInvited: this.softSkillsInvited
          })
          this.$router.replace('/sjt/completed/invitation')
          return
        }

        // If game was completed
        if (this.isCompleted) {
          this.$store.dispatch('setGameComplete', {
            playerResultId: this.$store.getters.playerResultId,
            softSkillsInvited: this.softSkills
          })
          this.$router.replace('/sjt/completed')
          return
        }

        this.$router.replace('/sjt/skill/completed')
      }

      this.bestChoiceID = null
      this.questionStartTime = Date.now()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~vars';
  @import '~mixins';

  .question-img{
    max-width:100%;
    height: auto;
  }

  .information-bar {
    font-size: $-font-size-s;
    font-style: italic;
    color: $-font-color-secondary;
  }

  .white-bubble {
    padding: $-grid-gutter $-padding-unit;
    margin: $-grid-gutter 0;
    background-color: $-color-white;
    border-radius: $-border-radius;
    box-shadow: 0 0 18px 4px rgba(144, 164, 183, 0.22);
    z-index: 1;
  }

  .responses-table {
    margin: ($-grid-gutter * 2) 0;
    box-shadow: 0 0 18px 4px rgba(144, 164, 183, 0.22);

    @include res('xs') {
      font-size: $-font-size-s;
    }
  }

  .submit-answer {
    margin: $-grid-gutter 0;
  }
</style>
